var menu_trigger = document.querySelector('.nav__toggle'),
    nav = document.querySelector('.nav'),
    body = document.querySelector('body'),
    nav_icon = document.querySelectorAll('.mega-nav__trigger'),
    sub_icon = document.querySelectorAll('.nav__icon--sub');

if (menu_trigger) {
    menu_trigger.addEventListener('click', function () {
        if (menu_trigger.classList.contains('nav__toggle--active')) {
            var openNavItem = nav.querySelector('.nav__link--active');
            if (openNavItem) {
                openNavItem.classList.remove('nav__link--active');
            }

            document.body.style.removeProperty('padding-right');
            document.removeEventListener(`keydown`, initTrapFocusNav);
        } else {
            //const documentWidth = document.documentElement.clientWidth;
            //const scrollbarWidth = Math.abs(window.innerWidth - documentWidth);
            //document.body.style.paddingRight = `${scrollbarWidth}px`;
            document.addEventListener('keydown', initTrapFocusNav);
        }

        // Toggle classes
        menu_trigger.classList.toggle('nav__toggle--active');
        nav.classList.toggle('nav--active');
        body.classList.toggle('nav--open');

        // Accessibility
        if (menu_trigger.getAttribute('aria-expanded') === 'true') {
            menu_trigger.setAttribute('aria-expanded', 'false');
        } else {
            menu_trigger.setAttribute('aria-expanded', 'true');
        }
    });
}

function initTrapFocusNav(e) {
    if (e.key === 'Escape') {
        var openNavItem = nav.querySelector('.nav__link--active');
        if (openNavItem) {
            openNavItem.classList.remove('nav__link--active');
        }

        document.body.style.removeProperty('padding-right');
        document.removeEventListener(`keydown`, initTrapFocusNav);

        menu_trigger.classList.remove('nav__toggle--active');
        nav.classList.remove('nav--active');
        body.classList.remove('nav--open');
        menu_trigger.setAttribute('aria-expanded', 'false');
    }

    trapFocus(e, 'header');
}

var navDropdowns = document.querySelectorAll('.nav__link--dropdown');
var navList = document.querySelector('.nav__list');

if (navDropdowns && navList) {
    navList.addEventListener('click', (e) => {
        if (e.target.classList.contains('nav__link--dropdown')) {
            var clickedDropdown = e.target;

            if (clickedDropdown.classList.contains('nav__link--active')) {
                // closing dropdown
                e.target.classList.remove('nav__link--active');
            } else {
                // opening dropdown
                var activeDropdowns = document.querySelectorAll('.nav__link--active');
                // want to close others first
                if (activeDropdowns) {
                    activeDropdowns.forEach((dropdown) => {
                        dropdown.classList.remove('nav__link--active');
                    });
                }

                clickedDropdown.classList.add('nav__link--active');
            }
        }
        if (e.target.classList.contains('nav__link--back')) {
            e.target
                .closest('.nav__list')
                .previousElementSibling.classList.remove('nav__link--active');
        }
    });
}

// TODO: clean up logic for show/hide nav and basket sidebar
var mainContent = document.getElementById('maincontent');

mainContent.addEventListener('click', () => {
    if (document.body.classList.contains('nav--open')) {
        document.body.style.removeProperty('padding-right');
        if (menu_trigger.classList.contains('nav__toggle--active')) {
            var openNavItem = nav.querySelector('.nav__link--active');
            if (openNavItem) {
                openNavItem.classList.remove('nav__link--active');
            }
        }

        // Toggle classes
        menu_trigger.classList.toggle('nav__toggle--active');
        nav.classList.toggle('nav--active');
        body.classList.toggle('nav--open');

        // Accessibility
        if (menu_trigger.getAttribute('aria-expanded') === 'true') {
            menu_trigger.setAttribute('aria-expanded', 'false');
        } else {
            menu_trigger.setAttribute('aria-expanded', 'true');
        }
    }
});

var header = document.querySelector('.header');

header.addEventListener('click', (e) => {
    if (
        document.body.classList.contains('nav--open') &&
        !e.target.classList.contains('nav__toggle') &&
        !document.querySelector('.nav').contains(e.target)
    ) {
        document.body.style.removeProperty('padding-right');
        if (menu_trigger.classList.contains('nav__toggle--active')) {
            var openNavItem = nav.querySelector('.nav__link--active');
            if (openNavItem) {
                openNavItem.classList.remove('nav__link--active');
            }
        }

        // Toggle classes
        menu_trigger.classList.toggle('nav__toggle--active');
        nav.classList.toggle('nav--active');
        body.classList.toggle('nav--open');

        // Accessibility
        if (menu_trigger.getAttribute('aria-expanded') === 'true') {
            menu_trigger.setAttribute('aria-expanded', 'false');
        } else {
            menu_trigger.setAttribute('aria-expanded', 'true');
        }
    }
});
